<div class="content_container">
  <div class="flex-grow-1 d-flex flex-column gap-4 template_text">
    <div class="bg-grey d-flex flex-column">

      <h2 class="title_1 mb-0 text-grad-blue">
        {{ 'PROCESSES.ACCOMMODATION.POST_RESERVATION_V2.CONTACT_TITLE' | translate }}
      </h2>

      <div class="img_container d-block d-sm-none position-relative w-100">
        <img class="img-cover br-8" loading="lazy" fill [ngSrc]="partner.imgMobile" [alt]="imgAltText">
      </div>
      <div>
        <h3 class="title_2 pb-1 txt-dark-blue">{{ 'COMMON.CONTACT_TITLE' | translate }}</h3>
        <ul>
          <li *ngIf="partner.contactInformations.mail">
            {{ 'COMMON.USER.EMAIL' | translate }} :
            <a href="mailto:{{partner.contactInformations.mail}}" class="text-decoration-none">{{ partner.contactInformations.mail }}</a>
          </li>
          <li *ngIf="partner.contactInformations.phone">
            {{ 'COMMON.USER.PHONE' | translate }} :
            <a href="tel:{{ partner.contactInformations.phone }}" class="text-decoration-none">{{ partner.contactInformations.phone }}</a>
          </li>
        </ul>
      </div>

      <div>
        <h3 class="title_2 pb-1 txt-dark-blue">{{ 'COMMON.INFORMATION' | translate }}</h3>
        <ul>
          <li *ngIf="partner.languages">
            {{ 'ROOM.ADVANTAGES.LANGUAGES' | translate }}
            <img loading="lazy" ngSrc="assets/img/flags/4x3/fr.svg" alt="" *ngIf="partner.languages.includes('france')" height="16" width="30">
            <img loading="lazy" ngSrc="assets/img/flags/4x3/gb.svg" alt="" *ngIf="partner.languages.includes('england')" height="16" width="30">
            <img loading="lazy" ngSrc="assets/img/flags/4x3/es.svg" alt="" *ngIf="partner.languages.includes('sp')" height="16" width="30">
          </li>
          <li>{{ 'COMMON.ANSWER_DELAY' | translate }} : 3 {{ 'COMMON.DAY'  | translate}}</li>
          <li *ngIf="partner.contactInformations.website">
            {{ 'COMMON.WEBSITE' | translate }} :
            <a target="_blank" rel="noopener noreferrer" (click)="setRedirection()" href="/redirect">{{ partner.contactInformations.website }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
